module.exports = window["MaterialUI"].TableHead;